import React from 'react';

interface Props {
	videoSrc: string;
	className?: string;
	videoRef?: React.Ref<HTMLVideoElement>;
	onPlay?: React.ReactEventHandler<HTMLVideoElement>;
	onPause?: React.ReactEventHandler<HTMLVideoElement>;
	onEnded?: React.ReactEventHandler<HTMLVideoElement>;
	autoPlay?: boolean;
	controls?: boolean;
}

const Video: React.FC<Props> = ({
	videoSrc,
	className,
	videoRef,
	onPlay,
	onPause,
	onEnded,
	autoPlay,
	controls,
}) => {
	return (
		<video
			ref={videoRef}
			className={className}
			width='100%'
			autoPlay={autoPlay}
			controls={controls}
			playsInline
			controlsList='nodownload'
			onPlay={onPlay}
			onPause={onPause}
			onEnded={onEnded}
		>
			<source src={videoSrc} type='video/mp4' />
		</video>
	);
};

export default Video;
